import React, { createContext, PropsWithChildren, useContext } from 'react';

import { formatLengthToArchitecturalString } from '@paragon/client-tools';

const DistanceFormattingContextObj = createContext(formatLengthToArchitecturalString);

export function DistanceFormattingContext(
  props: PropsWithChildren<{ formatLength: (lengthInInches: number) => string }>,
) {
  return (
    <DistanceFormattingContextObj.Provider value={props.formatLength}>
      {props.children}
    </DistanceFormattingContextObj.Provider>
  );
}

export function useActiveDistanceFormatter() {
  return useContext(DistanceFormattingContextObj);
}
